import React from "react";
import BookingCustomerInformation from "./customer/BookingCustomerInformation";

export default class BookingSignInSignUpModal extends React.Component {

  constructor(props) {
    super(props);

    this.onSignInSuccess = this.onSignInSuccess.bind(this);
    this.onSignUpSuccess = this.onSignUpSuccess.bind(this);
  }

  componentDidMount() {
    var $header = $(this.refs.header);
    $(window).on('scroll.SignInSignUp', function () {
      $header.css('top', $(window).scrollTop());
    });
  }

  componentWillUnmount() {
    $(window).off('scroll.SignInSignUp');
  }


  render() {
    return (
      <div className="BookingSignInSignUp">
        <div className="BookingSignInSignUpModal">
          <div className="BookingSignInSignUpModalHeader" ref="header">
            <h4>{I18n.t('sign_in_sign_up')}</h4>
            <a href="#" className="close-button" onClick={this.props.onToggleSignInSignUp}>{I18n.t('close')}</a>
          </div>
          <div className="BookingSignInSignUpModalContent">
            <div className="panel panel-default">
              <div className="panel-body">
                <BookingCustomerInformation {...this.props} 
                                            customerForm={this.props.signInSignUpModalCustomerForm} 
                                            customerFormName='signInSignUpModalCustomerForm'
                                            guestCustomerForm={false}
                                            onSignInSuccess={this.onSignInSuccess}
                                            onSignUpSuccess={this.onSignUpSuccess} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );    
  }

  /**
  * Change handlers
  */

  onSignInSuccess() {
    this.props.onToggleSignInSignUp()
  }

  onSignUpSuccess() {
    this.props.onToggleSignInSignUp()
  }

};
